import {CONTEXT_CAT_REF_DATA__GET} from "../actions";

export default function(state = {}, action) {

  switch (action.type) {
    case CONTEXT_CAT_REF_DATA__GET:
      //console.log('rdcr_context_cat_ref -- CONTEXT_CAT_REF_DATA__GET --  action.payload', action.payload)
      return action.payload;
    default:
      return state;
  }
}
